import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Input, Select, Tag, Switch, Button, message, Row, Col, Card, Space, Table, Tabs, Empty, Skeleton, Typography } from 'antd';
import dayjs from 'dayjs';
import TextArea from 'antd/es/input/TextArea';
import Currency from '../../../../components/common/Currency'; 
import ModalProporciones from './Proporciones';
import {getEmpleadoById} from '../../../../apis/OdooApi';
import {getList as getTiposLiquidacion} from '../../../../apis/TipoLiquidacionApi';
import {getList as getMotivosBaja} from '../../../../apis/MotivosBajaApi';
import {process, insert, update as updateFiniquito, getById as getFiniquitoById, getDetails, afectar as afectarFiniquito, print} from '../../../../apis/FiniquitoApi';
import {tipos_fecha, tipos_salario} from '../../../../constants/finiquito';
import {estatus_baja} from '../../../../constants/bajaEmpleado';
import {downloadFiniquito, emitFinquito} from '../../../../apis/TimbradoApi';
import ModalSaldos from './Saldos';

const { Text, Link } = Typography;
const { Option } = Select;

const AddOrEdit = ({ visible, onClose, recordId, finiquitoId, bajaData, onSave, update }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState([]);
    const [_recordId, setRecordId] = useState(recordId);
    const [empleado, setEmpleado] = useState(null);    
    const [detailData, setDetailData] = useState(bajaData);
    const [finiquito, setFiniquito] = useState(null);
    const [id, setId] = useState(finiquitoId);
    const [tipoFecha, setTipoFecha] = useState(null);
    const [tiposLiquidacion, setTiposLiquidacion] = useState([]);
    const [motivosBaja, setMotivosBaja] = useState([]);
    const [showCalculos, setShowCalculos] = useState(null);
    const [resultAcumulados, setResultAcumulados] = useState([]);
    const [resultConecepts, setResultConcepts] = useState([]);
    const [loadingTablas, setLoadingTablas] = useState(false);
    const [loadingCalculos, setLoadingCalculos] = useState(false);
    const [loadingTimbrar, setLoadingTimbrar] = useState(false);
    const [modalProporcionesVisible, setModalProporcionesVisible] = useState(false);
    const [modalSaldosVisible, setModalSaldosVisible] = useState(false);
    
    const [openConfirmAfectar, setOpenConfirmAfectar] = useState(false);
    const [afectar, setAfectar] = useState(false);
    const [timbrado, setTimbrado] = useState(false);
    const [loadinAfectar, setLoadingAfectar] = useState(false);
    
    const [openConfirmDesafectar, setOpenConfirmDesafectar] = useState(false);
    const [loadingDesafectar, setLoadingDesafectar] = useState(false);

    const [percepciones, setPercepciones] = useState(0);
    const [neto, setNeto] = useState(0);
    const [deducciones, setDeducciones] = useState(0);

    // Estados para los parámetros de la consulta
    const [periodoData, setPeriodoData] = useState({
        periodo_id: null,
        anio: new Date().getFullYear(),
        num_periodo: null
    });

    const effectRan = useRef(false);
    // Lógica de separación de conceptos y acumulados (copiada de la otra pantalla)
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                try {
                    if (visible && detailData) {
                        effectRan.current = true;
                        const currentYear = new Date().getFullYear();
                        let _empleado = await getEmpleado(detailData.odoo_empleado_id);
                        var values = {
                            empleado: _empleado.name,
                            nomina_employee_number: detailData.nomina_employee_number,
                            fecha_baja: detailData.fecha_baja ? dayjs(detailData.fecha_baja) : null,
                            definitivo: false,
                            anio: currentYear,
                        };
                        if (finiquitoId > 0) {
                            let _finiquito = await getFiniquito(finiquitoId);
                            await getCalculos(finiquitoId);
                            form.setFieldsValue({
                                ..._finiquito,
                                ...values,
                                tipo_liquidacion_id: _finiquito.tipo_liquidacion?.value,
                                motivo_baja_id: _finiquito.motivo_baja?.value,
                                fecha_baja: _finiquito.fecha_baja ? dayjs(_finiquito.fecha_baja) : null,
                                definitivo: _finiquito.definitivo,
                            });
                            setAfectar(_finiquito.definitivo);
                            setTimbrado(_finiquito.timbrado);
                        }else{
                            form.setFieldsValue({
                                ...values,
                            });
                        }
                        setLoading(false);
                    }
                } catch (error) {
                    console.log(error);
                }
            })();
        }
        return () => effectRan.current = true;
    }, [detailData]);

    const effectRanCatalogos = useRef(false);
    // Lógica de separación de conceptos y acumulados (copiada de la otra pantalla)
    useEffect(() => {
        if (!effectRanCatalogos.current) {
            (async () => {
                try {
                    if (visible && detailData) {
                        let responseTipoLiquidacion = await getTiposLiquidacion();
                        if(responseTipoLiquidacion.ok){
                            setTiposLiquidacion(responseTipoLiquidacion.payload);
                        }
                        let responseMotivosBaja = await getMotivosBaja();
                        if(responseMotivosBaja.ok){
                            setMotivosBaja(responseMotivosBaja.payload);
                        }
                    }
                } catch (error) {}
            })();
        }
        return () => effectRanCatalogos.current = true;
    }, []);

    // Función para limpiar datos (copiada de la otra pantalla)
    const clearData = (data) => {
        //1002 = deducciones
        const lines = data.filter(line => (line.dias > 0 || line.horas > 0 || line.exento > 0 || line.exento < 0 || line.monto > 0 || line.monto < 0) || line.concepto?.clave == '1002');
        return lines;
    }

    const getEmpleado = async (id)=>{
        const response = await getEmpleadoById(id);
        if(response.ok){
            let item = response.payload;
            setEmpleado(item);
            return item;
        }
        return response.payload;
    }

    const getFiniquito = async (id)=>{
        const response = await getFiniquitoById(id);
        if(response.ok){
            let item = response.payload;
            setFiniquito(item);
            return item;
        }
    }

    const getCalculos = async (id)=>{
        setLoadingCalculos(true);
        const responseDetails = await getDetails(id);
        if(responseDetails.ok){
            let configuration = responseDetails.payload.configuration;
            let items = responseDetails.payload.list;
            processCalculos(items, configuration);
        }
        setLoadingCalculos(false);
    }

    const processCalculos = async (items, configuration)=>{
        var conceptos = items.filter(x => !x.acumulado?.id);
        var acumulados = items.filter(x => x.acumulado?.id > 0);
        conceptos = clearData(conceptos);
        acumulados = clearData(acumulados);
        setResultConcepts(conceptos);
        setResultAcumulados(acumulados.sort((a, b) => a.concepto?.clave.localeCompare(b.concepto?.clave)));

        let _percepciones = acumulados.find(x=>x.acumulado?.id > 0 && x.concepto.id == configuration.concepto_percepcion_total);
        let _deducciones = acumulados.find(x=>x.acumulado?.id > 0 && x.concepto.id == configuration.concepto_deducción_total);
        let _neto = acumulados.find(x=>x.acumulado?.id > 0 && x.concepto.id == configuration.concepto_total_neto);
        setPercepciones(_percepciones?.monto);
        setDeducciones((-1)*_deducciones?.monto);
        setNeto(_neto?.monto);
        setShowCalculos(true);
    }
    
    const guardar = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            const finiquitoData = {
                baja_id: _recordId ?? recordId,
                tipo_fecha: values.tipo_fecha,
                tipo_liquidacion_id: values.tipo_liquidacion_id,
                motivo_baja_id: values.motivo_baja_id,
                descripcion: values.descripcion,
                comentarios: values.comentarios,
                perception_total: percepciones || 0,
                deduccion_total: deducciones || 0,
                neto_pagar: parseFloat(values.neto_pagar) || neto || 0,
                antiguedad_anios: parseInt(values.antiguedad_anios) || 0,
                antiguedad_mes: parseInt(values.antiguedad_mes) || 0,
                antiguedad_dias: parseInt(values.antiguedad_dias) || 0,
                tipo_salario: values.tipo_salario,
            };
            if (finiquitoId > 0) {
                finiquitoData.finiquito_id = finiquitoId;
                let response = await updateFiniquito(finiquitoData);
                if (response.ok) {
                    message.success('Se guardo correctamente la definición!');
                    setFiniquito(response.payload);
                    setLoading(false);
                    return true;
                } else {
                    message.error(response.message || 'Error al actualizar la liquidación');
                    setLoading(false);
                    return false;
                }
            } else {
                let response = await insert(finiquitoData);
                if (response.ok) {
                    message.success('Se guardo correctamente la definición!');
                    setFiniquito(response.payload);
                    setId(response.payload.id);
                    setLoading(false);
                    return true;
                } else {
                    message.error(response.message || 'Error al crear la liquidación');
                    setLoading(false);
                    return false;
                }
            }
        } catch (error) {
            setLoading(false);
            if (error.errorFields) {
                message.error('Por favor, complete todos los campos requeridos');
            } else {
                message.error(error.message || 'Error al crear la liquidación');
            }
            return false;
        }
    };
    const handleSubmit = async () => {
        await guardar();
    };


    const handleClose = () => {
        form.resetFields();
        setResult([]);
        setResultAcumulados([]);
        setResultConcepts([]);
        onClose();
    };

    const handleTipoChange = (value) => {
        const tipoSeleccionado = tiposLiquidacion.find(t => t.value === value);
        if (tipoSeleccionado) {
            form.setFieldValue('descripcion', tipoSeleccionado.text);
        }
    };

    const handleProporciones = () => {
        // Abrir el modal de proporciones
        setModalProporcionesVisible(true);
    };

    const handleProporcionesClose = () => {
        setModalProporcionesVisible(false);
    };
    
    const handleAfectar = () => {
        // message.info('Afectando liquidación...');
        setOpenConfirmAfectar(true);
    };

    const getFile = async (finiquitoId, file)=>{
        await downloadFiniquito(file, finiquitoId)
    }

    const confirmAfectar = async () => {
        setLoadingAfectar(true)
        try {
            const response = await afectarFiniquito(id, true);
            if(response.ok){
                setAfectar(true);
                setOpenConfirmAfectar(false);
                message.success('Liquidación afectada correctamente');
                update(estatus_baja.AFECTADO);
            } else {
                message.error(response.message || 'Error al afectar la liquidación');
            }
        } catch (error) {
            console.error('Error al afectar liquidación:', error);
            message.error(error.message || 'Error al afectar la liquidación');
        } finally {
            setLoadingAfectar(false);
        }
    };

    const handleDesafectar = () => {
        // message.info('Desafectando liquidación...');
        setOpenConfirmDesafectar(true);
    };

    const confirmDesafectar = async () => {
        setLoadingDesafectar(true)
        try {
            const response = await afectarFiniquito(id, false);
            if(response.ok){
                setAfectar(false);
                setOpenConfirmDesafectar(false);
                message.success('Liquidación desafectada correctamente');
                update(estatus_baja.PROCESO);
            } else {
                message.error(response.message || 'Error al desafectar la liquidación');
            }
        } catch (error) {
            console.error('Error al desafectar liquidación:', error);
            message.error(error.message || 'Error al desafectar la liquidación');
        } finally {
            setLoadingDesafectar(false);
        }
    };

    const handleSaldos = () => {
        if (!detailData?.odoo_empleado_id) {
            message.error('No se ha seleccionado un empleado válido');
            return;
        }
        setModalSaldosVisible(true);
    };

    const handleSaldosClose = () => {
        setModalSaldosVisible(false);
    };

    const ejecutarCalculo = async () => {
        setLoadingCalculos(true);
        try {
            const response = await process({finiquito_id: id});
            if (response.ok) {
                await processCalculos(response.payload.list, response.payload.configuration);
                setShowCalculos(true);
                setLoadingCalculos(false);
                message.success('Liquidación calculada correctamente');
            } else {
                message.error(response.message || 'Error al calcular la liquidación');
                setLoadingCalculos(false);
            }
        } catch (error) {
            console.error('Error al calcular liquidación:', error);
            message.error(error.message || 'Error al calcular liquidación');
            setLoadingCalculos(false);
        } finally {
            setLoadingCalculos(false);
        }
    };

    const handleCalcular = async () => {
        if (form.isFieldsTouched()) {
            Modal.confirm({
                title: 'Guardar cambios',
                content: 'El cálculo utiliza la información guardada de la liquidación. ¿Desea guardar los cambios antes de calcular?',
                okText: 'Guardar y calcular',
                cancelText: 'Cancelar',
                onOk: async () => {
                    const saved = await guardar();
                    if (saved) {
                        await ejecutarCalculo();
                    }
                }
            });
        } else {
            await ejecutarCalculo();
        }
    };

    const handleTimbrar = async () => {
         try {
            const response = await emitFinquito(id);
            if (response.ok) {
                message.success('Timbrado exitoso');
            } else {
                message.error(response.message || 'Error al timbrar la liquidación');
            }
        } catch (error) {
            console.error('Error al timbrar liquidación:', error);
            message.error(error.message || 'Error al timbrar liquidación');
        } finally {
            setLoadingTimbrar(false);
        }
    };

    const handleImprimir = async () => {
        await print(finiquitoId)
    };

    // Columnas de la tabla (copiadas de la otra pantalla)
    const columns = [
        {
            title: 'Tipo',
            dataIndex: 'concepto',
            key: 'concepto',
            render: (item, object) => {
                if (object.concepto?.tipo_concepto?.descripcion)
                    return object.concepto?.tipo_concepto?.descripcion;
                return '';
            }
        },
        {
            title: 'Concepto',
            dataIndex: 'concepto',
            key: 'concepto',
            render: (item, object) => {
                if (object.concepto?.clave)
                    return object.concepto?.clave;
                if (object.acumulado?.concepto?.clave)
                    return object.acumulado?.concepto?.clave;
                return '';
            }
        },
        {
            title: 'Descripción',
            dataIndex: 'concepto',
            key: 'concepto',
            render: (item, object) => {
                if (object.concepto?.descripcion)
                    return object.concepto?.descripcion;
                if (object.acumulado?.concepto?.descripcion)
                    return object.acumulado?.concepto?.descripcion;
                return '';
            }
        },
        {
            title: 'Días',
            dataIndex: 'dias',
            key: 'dias',
            render: (item) => {
                var value = item;
                if (item < 0)
                    value = item * (-1);
                return value;
            }
        },
        {
            title: 'Exento',
            dataIndex: 'exento',
            key: 'exento',
            render: (item) => {
                var value = item;
                if (item < 0)
                    value = item * (-1);
                return value;
            }
        },
        {
            title: 'Horas',
            dataIndex: 'horas',
            key: 'horas',
            render: (item) => {
                var value = item;
                if (item < 0)
                    value = item * (-1);
                return value;
            }
        },
        {
            title: 'Monto',
            dataIndex: 'monto',
            key: 'monto',
            render: (item) => {
                var value = item;
                if (item < 0)
                    value = item * (-1);
                return <Currency value={value} />;
            }
        },
        {
            title: 'Saldo Anterior',
            dataIndex: 'saldo_anterior',
            key: 'saldo_anterior',
            render: (item) => {
                return <Currency value={item} />;
            }
        },
        {
            title: 'Saldo Nuevo',
            dataIndex: 'saldo_nuevo',
            key: 'saldo_nuevo',
            render: (item) => {
                return <Currency value={item} />;
            }
        },
    ];

    return (<>
        <Modal
            title={"Nueva Liquidación"}
            open={visible}
            onCancel={handleClose}
            width={1400}
            footer={[]}
            destroyOnClose
            style={{ top: 20 }}
            bodyStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
        >
        {
            loading ? <Skeleton loading={loading}/>: <Form
                form={form}
                layout="vertical"
                size="middle"
                style={{ marginTop: 16 }}
            >
                {/* Formulario de liquidación */}
                <div style={{ 
                    border: '1px solid #d9d9d9', 
                    borderRadius: '6px', 
                    padding: '16px',
                    marginBottom: '16px'
                }}>
                    
                    {/* Empleado */}
                    <div style={{ 
                        backgroundColor: '#f0f0f0', 
                        padding: '8px', 
                        marginBottom: '8px',
                        borderRadius: '4px'
                    }}>
                        <strong>Empleado</strong>
                    </div>
                    
                    <Row gutter={16}>
                        <Col span={4}>
                            <Form.Item
                                name="nomina_employee_number"
                                label="Número de empleado"
                                rules={[{ required: true, message: 'Campo requerido' }]}
                            >
                                <Input placeholder="Número de empleado" disabled />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="empleado"
                                label="Nombre"
                                rules={[{ required: true, message: 'Campo requerido' }]}
                            >
                                <Input placeholder="Nombre del empleado" disabled />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="descripcion"
                                label="Descripción"
                                rules={[{ required: true, message: 'Campo requerido' }]}
                            >
                                <Input placeholder="Descripción" />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="tipo_liquidacion_id"
                                label="Tipo"
                                rules={[{ required: true, message: 'Campo requerido' }]}
                            >
                                <Select 
                                    placeholder="Seleccionar tipo"
                                    onChange={handleTipoChange}
                                >
                                    {tiposLiquidacion.map(tipo => (
                                        <Option key={tipo.value} value={tipo.value}>
                                            {tipo.text}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={4}>
                            <Form.Item
                                name="motivo_baja_id"
                                label="Motivo baja"
                                rules={[{ required: true, message: 'Campo requerido' }]}
                            >
                                <Select placeholder="Seleccionar motivo">
                                    {motivosBaja.map(motivo => (
                                        <Option key={motivo.value} value={motivo.value}>
                                            {motivo.text}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                name="tipo_fecha"
                                label="Fecha"
                                rules={[{ required: true, message: 'Campo requerido' }]}
                            >
                                <Select placeholder="Seleccionar un tipo de fecha" onChange={async (value) => {
                                    setTipoFecha(value)
                                }}>
                                    <Option key='INGRESO' value='INGRESO'>
                                        Ingreso
                                    </Option>
                                    <Option key='ANTIGUEDAD' value='ANTIGUEDAD'>
                                        Antigüedad
                                    </Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                name="tipo_salario"
                                label="Salario base"
                                rules={[{ required: true, message: 'Campo requerido' }]}
                            >
                                <Select placeholder="Seleccionar salario">
                                    {tipos_salario.list.map(item => (
                                        <Option key={item.value} value={item.value}>
                                            {item.text}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        </Row>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name="comentarios"
                                label="Comentarios"
                                rules={[{ required: true, message: 'Comentarios' }]}
                            >
                                <TextArea 
                                    placeholder="Ingrese comentarios"
                                    rows={3}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{span: 16}} sm={{span: 16}} xs={{span: 24}}>
                            <Space>
                                <Button key="cancel" onClick={handleClose}>
                                    Cancelar
                                </Button>
                                <Button 
                                    key="save" 
                                    type="primary" 
                                    onClick={handleSubmit}
                                    loading={loading}
                                    disabled={bajaData.status == estatus_baja.AFECTADO && (finiquito && finiquito.definitivo == false)}
                                >
                                    Guardar
                                </Button>
                                {
                                    finiquito && finiquito.timbrado && <>
                                        <Button type='primary' onClick={()=>{
                                            getFile(finiquitoId, 'xml');
                                        }}
                                        disabled={bajaData.status == estatus_baja.AFECTADO && finiquito.definitivo == false}
                                        >XML</Button>
                                        <Button type='primary'
                                        disabled={bajaData.status == estatus_baja.AFECTADO && finiquito.definitivo == false}
                                        onClick={()=>{
                                            getFile(finiquitoId, 'pdf');
                                        }}>PDF</Button>
                                    </>
                                }
                                
                            </Space>
                        </Col>
                    </Row>
                        
                </div>

                
                {/* Sección de acciones */}
                {
                    finiquito && 
                    <Card 
                        title="Acciones de Liquidación" 
                        size="small"
                        style={{ marginBottom: '16px' }}
                        headStyle={{ 
                            backgroundColor: '#f0f0f0', 
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        <Space size="middle" wrap>
                            <Button 
                                type="primary" 
                                onClick={handleProporciones}
                            >
                                Proporciones
                            </Button>
                            <Button 
                                type="primary" 
                                onClick={handleSaldos}
                            >
                                Saldos
                            </Button>
                            <Button 
                                type="primary" 
                                onClick={handleCalcular}
                                loading={loadingCalculos}
                                disabled={afectar == true}
                                // disabled={resultConecepts.length > 0}
                            >
                                Calcular
                            </Button>
                            <Button 
                                type="primary"
                                loading={loadinAfectar}
                                onClick={handleAfectar}
                                disabled={afectar == true}
                            >
                                Afectar
                            </Button>
                            <Button 
                                type="primary" 
                                onClick={handleImprimir}
                                disabled={afectar == false}
                            >
                                Imprimir
                            </Button>
                            <Button 
                                type="primary" 
                                loading={loadingDesafectar}
                                onClick={handleDesafectar}
                                disabled={afectar == false || timbrado == true}
                            >
                                Desafectar
                            </Button>
                            <Button 
                                type="primary" 
                                loading={loadingTimbrar}
                                onClick={handleTimbrar}
                                disabled={afectar == false || timbrado == true}
                            >
                                Timbrar
                            </Button>
                            <Button 
                                type="default" 
                                disabled
                            >
                                Salir
                            </Button>
                        </Space>
                    </Card>
                }
                
                {
                    showCalculos && <>
                        {/* Sección de tablas */}
                        <Card 
                            title="Datos de Calculo" 
                            size="small"
                            headStyle={{ 
                                backgroundColor: '#f0f0f0', 
                                fontSize: '14px',
                                fontWeight: 'bold'
                            }}
                        >
                            {loadingTablas ? (
                                <Skeleton active={loadingTablas} />
                            ) : (
                                <Tabs
                                    defaultActiveKey="1"
                                    items={[
                                        {
                                            key: '1',
                                            label: 'Recibo',
                                            children: <>
                                                {resultConecepts.length === 0 ? (
                                                    <Empty description="No hay datos de liquidación. Configure el período y presione 'Proporciones' para calcular." />
                                                ) : (
                                                    <Table 
                                                        dataSource={resultConecepts} 
                                                        columns={columns} 
                                                        pagination={false}
                                                        size="small"
                                                        scroll={{ x: true }}
                                                    />
                                                )}
                                            </>
                                        },
                                        {
                                            key: '2',
                                            label: 'Acumulados',
                                            children: <>
                                                {resultAcumulados.length === 0 ? (
                                                    <Empty description="No hay datos de liquidación. Configure el período y presione 'Proporciones' para calcular." />
                                                ) : (
                                                    <Table 
                                                        dataSource={resultAcumulados} 
                                                        columns={columns} 
                                                        pagination={false}
                                                        size="small"
                                                        scroll={{ x: true }}
                                                    />
                                                )}
                                            </>
                                        }
                                    ]}
                                />
                            )}
                        </Card>
                    </>
                }
                
            </Form>
        }
        </Modal>
        {
            modalProporcionesVisible && finiquito && 
            <ModalProporciones
                visible={modalProporcionesVisible}
                onClose={handleProporcionesClose}
                bajaData={bajaData}
                finiquito={finiquito}
                disabled={afectar == true}
            />
        }
                
        {
            modalSaldosVisible && finiquito && 
            <ModalSaldos
                visible={modalSaldosVisible}
                onClose={handleSaldosClose}
                bajaData={bajaData}
                finiquito={finiquito}
            />
        }
        <Modal
            title="Confirmar afectación"
            open={openConfirmAfectar}
            onOk={confirmAfectar}
            onCancel={()=>{setOpenConfirmAfectar(false)}}
            okText="Aceptar"
            cancelText="Cancelar"
        >
            <p>¿Confirmas que deseas afectar el finiquito?</p>
        </Modal>
        <Modal
            title="Confirmar desafectación"
            open={openConfirmDesafectar}
            onOk={confirmDesafectar}
            onCancel={()=>{setOpenConfirmDesafectar(false)}}
            okText="Aceptar"
            cancelText="Cancelar"
        >
            <p>¿Confirmas que deseas adesafectar el finiquito?</p>
        </Modal>
        </>
    );
};

export default AddOrEdit;